var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('naj-box',{attrs:{"title":_vm.local.agentForm.title}},[_c('attorney-form',{attrs:{"form-model":_vm.formModel,"attorney-social-id":_vm.agentSocialId,"related-social-id":_vm.clientId,"view-mode":_vm.viewMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }